import * as actionTypes from './actionTypes';
import constants from "../../utils/constants";

const log = require("loglevel").getLogger("databaseBackupsReducer");
log.setLevel("debug");

const initialState = JSON.stringify({
	snapshots: null,
});

function databaseBackupsReducer(state = JSON.parse(initialState), action) {
	switch (action.type) {
		case constants.GLOBAL_ACTION_INIT_STATE: {
			log.debug("reset program state");
			return initialState;
		}
		case actionTypes.SNAPSHOTS_LOADED: {
			return {
				...state,
				snapshots: action.data
			};
		}
		default:
			return state;
	}
}

export default databaseBackupsReducer;
